import React, { useCallback } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import Traductor from '../../Traductor';
import ManagementFiltersFooter from './ManagementFiltersFooter';

const ManagementFiltersForm = ({ filters, onSubmit, onClose }) => {
    const t = new Traductor();

    const renderStatusOptions = useCallback(
        (onChange, currentStatusOptions) => {
            return Object.entries(currentStatusOptions).map(([key, value]) => {
                return (
                    <label className="c-checkbox u-mb-small" key={key}>
                        <input
                            className="c-checkbox__input"
                            type="checkbox"
                            name={key}
                            checked={value}
                            onChange={() =>
                                onChange('status', {
                                    ...currentStatusOptions,
                                    [key]: !value,
                                })
                            }
                        />
                        <span className="c-checkbox__label">
                            {t.getTraduction(`ManagementFiltersStatus`)[key]}
                        </span>
                    </label>
                );
            });
        },
        []
    );

    return (
        <Formik
            initialValues={filters}
            onSubmit={onSubmit}
            validationSchema={Yup.object().shape({
                name: Yup.string(),
            })}
        >
            {({ values, handleSubmit, setFieldValue, errors, isValid }) => (
                <>
                    <div
                        className="c-modal__content u-align-start"
                        role="document"
                    >
                        <form action="#">
                            <div className="c-form-field u-mb">
                                <label
                                    htmlFor={t.getTraduction(
                                        `TrolleyFormNameLabel`
                                    )}
                                    className="c-form-field__label u-mb u-h6 u-text-brand"
                                >
                                    {t.getTraduction(`TrolleyFormNameLabel`)}
                                </label>
                                <div className="c-form-field__box">
                                    <div className="c-input">
                                        <input
                                            id={t.getTraduction(
                                                `TrolleyFormNameLabel`
                                            )}
                                            className="c-input__input"
                                            name="name"
                                            type="text"
                                            placeholder={t.getTraduction(
                                                `TrolleyFormNamePlaceholder`
                                            )}
                                            onChange={e =>
                                                setFieldValue(
                                                    'name',
                                                    e.target.value
                                                )
                                            }
                                            value={values.name}
                                        />
                                    </div>
                                    <p className="c-error-message">
                                        {errors.name}
                                    </p>
                                </div>
                            </div>
                            <div className="c-form-field">
                                <div className="c-form-field__label u-mb u-h6 u-text-brand">
                                    {t.getTraduction(
                                        'MyBatchesFormStatusLabel'
                                    )}
                                </div>
                                <div
                                    className="c-form-field__box"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    {renderStatusOptions(
                                        setFieldValue,
                                        values.status
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                    <ManagementFiltersFooter
                        onClose={onClose}
                        onSubmit={handleSubmit}
                    />
                </>
            )}
        </Formik>
    );
};

export default ManagementFiltersForm;
